const INACTIVE_SSF_DEDUCTION_TITLE =
  "ค่าซื้อหน่วยลงทุนในกองทุนรวมเพื่อการออม (SSF)";

const CURRENT_TAX_PLAN_DEDUCTION_FIELDS = [
  "tax_plan_insurance_life",
  "tax_plan_insurance_health",
  "tax_plan_insurance_annuity",
  "tax_fund_provident",
  "tax_fund_nsf",
  "tax_plan_rmf",
  "tax_plan_political_donate",
  "tax_fund_esg",
];

// ยอดลดหย่อนปัจจุบันรับเฉพาะ number ที่เป็น finite และไม่ติดลบ เพื่อไม่ให้ field ที่หายหรือผิดรูปแบบทำให้ยอดรวมเป็น NaN
const normalizeCurrentDeductionAmount = (value) => {
  return Number.isFinite(value) && value >= 0 ? value : 0;
};

// เก็บค่า SSF เดิมไว้ในข้อมูลต้นฉบับ แต่ตัดออกจากสำเนาที่ใช้คำนวณภาษีปัจจุบัน
export const normalizeCurrentTaxCalculationData = (taxData = {}) => {
  const deductionFirst = Array.isArray(taxData?.deduction_first)
    ? taxData.deduction_first.filter(
        (item) => item?.title !== INACTIVE_SSF_DEDUCTION_TITLE
      )
    : taxData?.deduction_first;

  return {
    ...taxData,
    fund_provident_ssf_value: 0,
    tax_plan_ssf: 0,
    deduction_first: deductionFirst,
  };
};

// ยอดวางแผนภาษีปัจจุบันนับเฉพาะรายการที่ยังใช้งาน และไม่รวม SSF ที่ไม่มี control แล้ว
export const calculateCurrentTaxPlanDeductionTotal = (taxData = {}) => {
  const currentTaxData = normalizeCurrentTaxCalculationData(taxData);

  return CURRENT_TAX_PLAN_DEDUCTION_FIELDS.reduce(
    (total, field) =>
      total + normalizeCurrentDeductionAmount(currentTaxData?.[field]),
    0
  );
};
